import { SendGETServerAPI } from "../../customFunctions/Api.js";
export default {
    state: {
        projects: []
    },
    actions: {
        async setAllProjects(ctx, state) {
            if (!state.projects.projects || state.projects.projects.length === 0) {
                try {
                    const response = await SendGETServerAPI(
                        "home/GetProjects", {
                        Authorization: "Bearer " + state.security.accessToken
                    }
                    );

                    ctx.commit('setAllProjectsMutation', response)
                }
                catch (e) {
                    console.log(e, 'setAllProjects exception')
                }
            }
        }
    },
    mutations: {
        setAllProjectsMutation(state, values) {
            state.projects = values
        }
    },
    getters: {
        getAllProjects(state) {
            return state.projects;
        }
    },
}